import React, { createRef } from 'react';
import TablePage from "../../../common/TablePage";
import {bindActionCreators} from "redux";
import * as Actions from "../../../actions/Actions";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../../localization";
import {withSnackbar} from "notistack";
import PageState from '../../../constants/PageState';
import {
    LinearProgress, ListItemIcon, ListItemText, Menu, MenuItem,
    TableBody,
    TableCell, TableFooter,
    TableHead, TablePagination,
    TableRow, TextField
} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import {transformDate} from "../../../util/DateUtil";
import CONFIG from "../../../config";
import {sortTable} from "../../../util/DataUtil";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import UndoIcon from "@material-ui/icons/Undo";
import Button from "@material-ui/core/Button";
import ServicesModal from "../../../common/admin/ServicesModal";
import Dropzone from "react-dropzone";
import VatProxiesForm from "../../../components/forms/admin/vatProxies/VatProxiesForm";
import {addVatProxy, deleteVatProxy, editVatProxy, getAllVatProxies} from "../../../services/admin/VatProxiesService";
import {getAllCorStates} from "../../../services/admin/CorStatesService";
import AccountTypes from "../../../constants/AccountTypes";

class AdminVatProxies extends TablePage {

    tableDescription = [
        { key: 'name', label: strings.vatProxies.name },
        { key: 'address', label: strings.vatProxies.address },
        { key: 'pib', label: strings.vatProxies.pib },
        { key: 'date_of_confirmation', label: strings.vatProxies.confirmationDate, transform: 'date' },
        { key: 'foreign_correspondent', label: strings.vatProxies.foreignCorrespondent, transform: 'date'  },
        { key: 'date_of_termination', label: strings.vatProxies.dateOfTermination, transform: 'date'  },
        { key: 'start_date', label: strings.vatProxies.startDate, transform: 'date'  },
        { key: 'deletion_date', label: strings.vatProxies.deleteDate, transform: 'date'  },
    ];

    constructor(props) {
        super(props);

        this.state = {
            data: props.data ? props.data : {},
            showSearch: true,
            showAdd: true,
            // tableData: [],
            tableData: [],
            pageState: PageState.View,
            total: 100,
            errors: {},
            openModal: false,
            uploadedFile: null,
            searchData : {
                total : 0,
                search : '',
                page : 1,
                perPage : 30
            }
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.dropzoneRef = createRef();
    }

    date(item){
        if (!item){
            return '';
        }
        var s = item;

        if (typeof s !== 'string'){
            return item;
        }

        var n = s.indexOf('T');
        return s.substring(0, n != -1 ? n : s.length)
    }

    dateSlash(item){
        if (!item){
            return '';
        }
        var s = item;

        if (typeof s !== 'string'){
            return item;
        }

        var n = s.indexOf('T');
        return new Date(s.substring(0, n != -1 ? n : s.length));
    }

    fetchData() {
        getAllVatProxies(this.state.searchData).then(response => {
            if (!response.ok) {
                return;
            }

            this.setState({
                tableData: response.data.result,
                searchData : {
                    ...this.state.searchData,
                    page : response.data.page,
                    perPage : response.data.perPage,
                    total : Math.ceil(response.data.total/response.data.perPage)
                }
            });
        });
    }

    componentDidMount() {
        if (this.getUser() && (AccountTypes.ADMIN !== this.getUser().type)){
            this.props.history.push('/');
            return
        }

        this.fetchData();
    }

    renderDate(item){
        if(!item){
            return '';
        }

        return transformDate(item);
    }

    renderDownloadImage() {
        return (
            <img src={'/images/direct-download1.svg'} alt={'download'}/>
        );
    }

    // TABLE

    sortTable(param){
        let sortedData = sortTable(this.state.tableData, param);

        this.setState({
            tableData: sortedData
        })
    }

    getPageHeader() {
        return <h1>{ strings.vatProxies.mainTitle }</h1>;
    }

    getPageDescription(){
        return <h3>{ strings.vatProxies.pageDescription }</h3>
    }

    renderTableHeader() {

        let result = [];

        for(let item of this.tableDescription) {
            if(item.label !== 'Download'){
                result.push(
                    <TableCell key={ 'table-header-' + result.length } onClick={() => this.sortTable(item.key)} style={{cursor: 'pointer'}}>
                        <div>
                            { item.label }
                            <div className={'sort-icon'}>
                                <img src={'/images/Polygon2.svg'} />
                                <img src={'/images/Polygon3.svg'} />
                            </div>
                        </div>
                    </TableCell>
                )
            }else {
                result.push(
                    <TableCell key={ 'table-header-' + result.length } style={{cursor: 'default'}}>
                        <div>
                            { item.label }
                        </div>
                    </TableCell>
                )
            }
        }

        return (
            <TableHead className='table-header'>
                <TableRow>
                    { result }
                    <TableCell>
                        {/*{ strings.table.actions }*/}
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }

    renderTableRowData(item) {

        let result = [];

        for(let description of this.tableDescription) {
            if(description.label !== 'Download'){
                result.push(
                    <TableCell key={ 'table-data-' + description.key + '-' + result.length }>
                        {
                            description.transform !== undefined &&
                            this[description.transform](item[description.key])
                        }
                        {
                            description.transform === undefined &&
                            item[description.key]
                        }
                    </TableCell>
                );
            }else {
                result.push(
                    <TableCell key={ 'table-data-' + description.key + '-' + result.length } style={{textAlign: 'center'}}>
                        {
                            description.transform !== undefined &&
                            this[description.transform](item[description.key])
                        }
                        {
                            description.transform === undefined &&
                            item[description.key]
                        }
                    </TableCell>
                );
            }
        }

        return result;
    }

    renderTableControls() {
        return [
            <Button variant="contained" color="secondary"
                // onClick={ () => this.setPageState(PageState.Add) }
                    onClick={ () => this.toggleModal() }
            >
                { strings.table.addDocument }
            </Button>
        ]
    }

    renderRowMenu(index, item) {

        let ariaOwns = 'action-menu-' + index;

        return(
            <TableCell>
                <IconButton
                    aria-owns={ this.state.anchorEl ? ariaOwns : undefined }
                    aria-haspopup="true"
                    onClick={ (event) => this.handleMenuClick(event, ariaOwns) }
                >
                    <MoreVert/>
                </IconButton>
                {
                    ariaOwns === this.state.ariaOwns &&
                    <Menu
                        id={ ariaOwns }
                        anchorEl={ this.state.anchorEl }
                        open={ Boolean(this.state.anchorEl) }
                        onClose={ () => this.handleMenuClose() }
                        className={'table-additional-menu'}
                    >
                        <div className={'menu-header'}>
                            {  strings.table.additionalOptions}
                        </div>
                        <MenuItem onClick={ () => this.toggleModal(item) }>
                            <ListItemIcon>
                                <EditIcon/>
                            </ListItemIcon>
                            <ListItemText inset primary={ strings.table.edit }/>
                        </MenuItem>
                        {
                            !item[this.deletedField] &&
                            <MenuItem onClick={ () => this.delete(item) }>
                                <ListItemIcon>
                                    <DeleteIcon/>
                                </ListItemIcon>
                                <ListItemText inset primary={ strings.table.delete }/>
                            </MenuItem>
                        }
                        {
                            item[this.deletedField] &&
                            <MenuItem onClick={ () => this.handleRestore(item) }>
                                <ListItemIcon>
                                    <UndoIcon/>
                                </ListItemIcon>
                                <ListItemText inset primary={ strings.table.undo }/>
                            </MenuItem>
                        }

                    </Menu>
                }

            </TableCell>
        );
    }

    // MODAL SECTION

    toggleModal(item) {
        this.setState({
            openModal: !this.state.openModal,
            data: item ? item : {},
            pageState: item ? PageState.Edit : PageState.Add
            // data: {
            //     ...this.state.data,
            //     item
            // }
        });
    }

    openDialog() {
        if (this.dropzoneRef.current) {
            this.dropzoneRef.current.open();
        }
    };

    onDrop(acceptedFile) {

        this.setState({
            uploadedFile: acceptedFile[0]
        })

        // let applicationFile = new FormData();
        // applicationFile.append('application', this.state.application.id);
        // applicationFile.append('name', acceptedFile.name);
        // applicationFile.append('content', acceptedFile);
        // applicationFile.append('fileType', acceptedFile.type);
        // applicationFile.append('type', this.state.fileUploadModal);

        // uploadFiles(applicationFile).then((result) => {
        //     let files = this.state.files;
        //
        //     files.push(result.data);
        //
        //     this.setState({
        //         files: files
        //     });
        // });
    }

    add(){
        this.state.data.date_of_confirmation = this.state.data.date_of_confirmation ? this.state.data.date_of_confirmation.toLocaleDateString("en-US").toString().split('T')[0] : '';
        this.state.data.date_of_termination = this.state.data.date_of_termination ? this.state.data.date_of_termination.toLocaleDateString("en-US").toString().split('T')[0] : '';
        this.state.data.deletion_date = this.state.data.deletion_date ? this.state.data.deletion_date.toLocaleDateString("en-US").toString().split('T')[0] : '';
        this.state.data.start_date = this.state.data.start_date ? this.state.data.start_date.toLocaleDateString("en-US").toString().split('T')[0] : '';

        addVatProxy(this.state.data).then(response => {
            if (!response.ok) {
                this.props.enqueueSnackbar(strings.login.error, { variant: 'error' });
                return;
            }

            setTimeout(()=> {
                this.props.enqueueSnackbar(strings.login.success, { variant: 'success' })
                this.fetchData();
            }, 1000)
        });

        this.toggleModal(this.state.data);
    }

    edit(){
        this.state.data.date_of_confirmation = typeof this.state.data.date_of_confirmation !== 'string' ? this.state.data.date_of_confirmation.toLocaleDateString("en-US").toString().split('T')[0] : this.state.data.date_of_confirmation;
        this.state.data.date_of_termination = typeof this.state.data.date_of_termination !== 'string' ? this.state.data.date_of_termination.toLocaleDateString("en-US").toString().split('T')[0] : this.state.data.date_of_termination;
        this.state.data.deletion_date = typeof this.state.data.deletion_date !== 'string' ? this.state.data.deletion_date.toLocaleDateString("en-US").toString().split('T')[0] : this.state.data.deletion_date;
        this.state.data.start_date = typeof this.state.data.start_date !== 'string' ? this.state.data.start_date.toLocaleDateString("en-US").toString().split('T')[0] : this.state.data.start_date;

        editVatProxy(this.state.data).then(response => {
            if (!response.ok) {
                this.props.enqueueSnackbar(strings.login.error, { variant: 'error' });
                return;
            }

            setTimeout(() => {
                this.props.enqueueSnackbar(strings.login.success, { variant: 'success' })
                this.fetchData();
            }, 1000)
        });

        this.toggleModal(this.state.data);
    }

    delete(){
        deleteVatProxy(this.state.selectedItem.id).then(response => {
            if (!response.ok) {
                this.props.enqueueSnackbar(strings.login.error, { variant: 'error' });
                return;
            }

            setTimeout(()=> {
                this.props.enqueueSnackbar(strings.login.success, { variant: 'success' })
                this.fetchData();
            }, 1000)
        });
    }

    modalRender() {
        return (
            <ServicesModal
                toggleModal={this.toggleModal}
                open={this.state.openModal}
                // open={true}
                deleteFile={this.deleteFile}
                onChange={this.changeData}
                data={this.state.data}
                openDialog={this.openDialog}
                showHeader={true}
                form={
                    <VatProxiesForm
                        dateSlash={this.dateSlash}
                        data={this.state.data}
                        openDialog={this.openDialog}
                        uploadedFile={this.state.uploadedFile}
                        onChange={this.changeData}
                        onAdd={this.add}
                        onEdit={this.edit}
                        pageState={this.state.pageState}
                    />
                }
                content={
                    <div className={'dropzone-wrapper'}>
                        <Dropzone
                            onDrop={this.onDrop}
                            multiple={true}
                            ref={this.dropzoneRef}
                            accept={CONFIG.acceptFiles}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <div>
                                    <section className={'file-dropzone'}>
                                        <div {...getRootProps()} className={'cursor-pointer'}>
                                            <input {...getInputProps()} />
                                        </div>
                                    </section>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                }
            />
        );
    }

    render() {
        let modal = this.modalRender();

        return (
            <div id={'admin-table-page'}>
                <Grid id='admin-table'>
                    <div className='header'>
                        { this.getPageHeader() }
                        { this.getPageDescription() }
                    </div>
                    <div className='filter-controls'>

                        {
                            this.state.showSearch &&
                            <div className={'filter-wrapper'}>
                                <TextField
                                    placeholder={ strings.table.search }
                                    type="search"
                                    name='search'
                                    value={ this.state.searchData.search }
                                    onChange={ this.searchChanged }
                                    variant={'outlined'}
                                    className={'filter-input'}
                                />
                            </div>
                        }

                        {
                            this.state.showAdd &&
                            this.renderTableControls()
                        }
                    </div>
                    <div className={'table-wrapper'} md={12}>
                        { this.renderTable(this.state.tableData) }
                    </div>
                    {modal}
                </Grid>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen
    }, dispatch);
}

function mapStateToProps({ menuReducers, filterReducers, authReducers })
{
    return { menu: menuReducers, filter: filterReducers, user: authReducers.user, };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminVatProxies)));